import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';
import {Link} from 'shells/link/link';

import {buildChatLeadsUrl} from '../actions-options/helpers';

export function ChatLeadsLink() {
    const chatLeadsUrl = buildChatLeadsUrl(
        NutshellFrontendSettings.originApiIdChat,
        NutshellFrontendSettings.originApiIdChatbot
    );

    return (
        <Link
            size='small'
            newTab={true}
            href={chatLeadsUrl}
            variant='primary'
            icon={ExternalLinkIcon}
        >
            View leads from chat
        </Link>
    );
}
